import createCache, { type EmotionCache } from "@emotion/cache";

const EMOTION_CACHE_KEY = "remix-css";

const createEmotionCache = () => {
  // Type casting required only during the emotion TypeScript migration
  return createCache({ key: EMOTION_CACHE_KEY }) as EmotionCache;
};

export { createEmotionCache, EMOTION_CACHE_KEY };
